import { Injectable } from '@angular/core';
import { catchError } from "rxjs/internal/operators";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HelpService {

  private baseUrl = 'https://open.sukandaonelink.com/docs';
    //private baseUrl = 'http://localhost:8080/server';
  private handleError(error: HttpErrorResponse) {
    let errorMessage = "Something bad happened; please try again later.";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  constructor(private http: HttpClient) {}

  getSales(): Observable<any[]> {
    const headers = { 'dc': '', 'email': '' }
    return this.http
      .get<any[]>(this.baseUrl + '/getSales',{'headers':headers})
      .pipe(catchError(this.handleError));
  }

    getCustomerReq(id: String): Observable<any> {

        return this.http.get(`${this.baseUrl}/getCustomerReq?id=${id}`);
    }

    getCustomerShipTo(shipTo:string):Observable<any>{
        const headerDict = {
            'shipto': shipTo,
          }
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
          };
        return this.http.get(`${this.baseUrl}/getShipto`,requestOptions);
    }

    getCustomerBillTo(billTo :string):Observable<any>{
        const headerDict = {
            'billTo': billTo ,
          }
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
          };
        return this.http.get(`${this.baseUrl}/getBillTo`,requestOptions);
    }

    searchBillTo(billTo :string):Observable<any>{
        const headerDict = {
            'billTo': billTo ,
          }
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
          };
        return this.http.get(`${this.baseUrl}/getListBillTo`,requestOptions);
    }

    saveSalesForm(registerForm,listShipTo:any):any{
      const headerDict = {
        'shipTo': listShipTo ,
      }
    const requestOptions = {
        headers: new HttpHeaders(headerDict),
      };
      return this.http.post(`${this.baseUrl}/saveSalesReq`,registerForm,requestOptions);
    }

      //Adding headers

  //Adding headers
  getCity(): Observable<any[]> {
    const headers = { 'city': '' }
    return this.http
    .get<any[]>(this.baseUrl + '/getCity',{'headers':headers})
    .pipe(catchError(this.handleError));

  }

  getBusinessCategory(): Observable<any[]> {
    return this.http
    .get<any[]>(this.baseUrl + '/getBusinessType')
    .pipe(catchError(this.handleError));

  }

  getProvince(): Observable<any[]> {
    return this.http
    .get<any[]>(this.baseUrl + '/getProvince')
    .pipe(catchError(this.handleError));

  }

  // postSaveCustomerReq(submit: any): Observable<any> {
  //   return this.http
  //     .post(`${this.baseUrl}/saveCustomerReq`, submit)
  //     .pipe(catchError(this.handleError));
  // }

  postSaveCustomerNewReq( postSaveCustomerNewReq): any {
    return this.http.post(`${this.baseUrl}/saveCustomerNewReq`, postSaveCustomerNewReq);
  }

   postSaveCustomerReq( postSaveCustomerReq): any {
    return this.http.post(`${this.baseUrl}/saveCustomerReq`, postSaveCustomerReq);
  }

  postComplaint(postComplaint): any {
    return this.http.post(`${this.baseUrl}/savecomplaint`, postComplaint);
  }
}



